export enum EAddExpenseSplitMode {
  EQUAL = 'equal',
  CUSTOM = 'custom',
}

// Min date is first day of 2026 (year feature the was released)
export const MIN_DATE = new Date(2026, 0, 1);
export const MAX_DATE = new Date();

export const MO_ICON_SRC = '/assets/images/etc/MoIcon.svg';
